import addMount from "../../core/addMount";
import AdvancedSearchEntry from "./AdvancedSearch.entry";

addMount({ appName: "advanced-search", app: AdvancedSearchEntry });
